// extracted by mini-css-extract-plugin
export default {"title":"delete_title__VMiW3","buttonPart":"delete_buttonPart__0QEun","buttonCancel":"delete_buttonCancel__+8bdG","buttonDelete":"delete_buttonDelete__fXmpo"};